<template>
  <div>
    <div class="col-12 col-md-4 col-lg-3">
      <trans-select3
        :value.sync="memberGroup"
        :items="memberGroups"
        :label="$t('headers.members_management.Member Group')"
        item-value="IdentityId"
        :rules="[$rules.required]"
        class="required"
      />
    </div>
    <pbas-data-table
      v-if="memberGroup"
      ref="table"
      :dataProvider="provider"
      :rowActions="rowActions"
      :floatActions="floatActions"
      :selectActions="selectActions"
      sortBy="Name"
      :exporters="$exporters"
      @error="error = $event"
    ></pbas-data-table>

    <drug-edit
      :drug="editdrug"
      @cancel="editdrug = null"
      @update:drug="
        editdrug = null;
        $refs.table.getDataAsync();
      "
    ></drug-edit>
    <v-dialog v-model="showImport" max-width="700" scrollable>
      <drug-import
        v-if="showImport"
        @cancel="showImport = false"
        @upload="$refs.table.getDataAsync()"
        :provider="$refs.table"
      />
    </v-dialog>
    <v-dialog v-model="showAssignments" scrollable max-width="700">
      <drug-coverage-assignments
        v-if="showAssignments"
        :showCancel="true"
        @cancel="showAssignments = false"
        @saved="showAssignments = false"
      ></drug-coverage-assignments>
    </v-dialog>
    <drugs-info :show.sync="showInfo"></drugs-info>
    <error-handler :error="error" />
  </div>
</template>

<script>
import DrugHeaders from "../../headers/Drugs";
import { ODataProvider } from "pbas-vue-components";
import { mapActions, mapGetters } from "vuex";
import DrugEdit from "./DrugEdit";
import DrugImport from "./DrugImport";
import DrugCoverageAssignments from "./DrugCoverageAssignments";
import ErrorHandler from "../../components/ErrorHandler";
import DrugsInfo from "./DrugsInfo";
import TransSelect3 from "../TransSelect3.vue";

export default {
  components: {
    DrugEdit,
    ErrorHandler,
    DrugImport,
    DrugCoverageAssignments,
    DrugsInfo,
    TransSelect3,
  },
  props: ["cms"],
  data: function() {
    return {
      showInfo: false,
      editdrug: null,
      provider: undefined,
      headers: DrugHeaders,
      error: null,
      showAssignments: false,
      showImport: false,
      rowActions: [
        {
          name: "edit",
          icon: "edit",
          title: "globals.edit",
          handler: (item) => this.edit(item),
        },
        {
          name: "remove",
          icon: "delete",
          title: "globals.remove",
          handler: (item) => this.remove(item),
        },
      ],
      floatActions: [
        {
          name: "assignCoverage",
          icon: "assignment_turned_in",
          color: this.$vuetify.theme.themes.light.primary,
          text: "globals.assign",
          handler: () => {
            this.showAssignments = true;
          },
        },
        {
          name: "addItem",
          icon: "add",
          color: this.$vuetify.theme.themes.light.success,
          text: "globals.add_new",
          handler: () => {
            this.edit({ Din: null, Name: "", PlanId: this.selectedPlan.Id });
          },
        },
        {
          name: "import",
          icon: "cloud_upload",
          color: this.$vuetify.theme.themes.light.primary,
          text: "globals.import",
          handler: () => {
            this.showImport = true;
          },
        },
        {
          name: "info",
          icon: "article",
          color: this.$vuetify.theme.themes.light.primary,
          text: "components.drugs.druglist.info",
          handler: () => {
            this.showInfo = true;
          },
          visible: () => this.cms === "old",
        },
      ],
      selectActions: [
        {
          name: "delete",
          icon: "delete",
          title: "globals.remove",
          handler: (items) => {
            items.forEach((i) => this.remove(i));
          },
        },
      ],
      memberGroups: [],
      memberGroup: null,
    };
  },
  computed: {
    ...mapGetters("common", { selectedPlan: "plan", settings: "settings" }),
    url() {
      if (this.cms === "old") {
        // if (this.memberGroup === null || this.memberGroup === undefined) {
        return (
          this.settings.APIURL +
          "cms/odata/plans/" +
          this.selectedPlan.Id +
          "/Drugs"
        );
        // }
        // return (
        //   this.settings.APIURL +
        //   "cms/odata/plans/" +
        //   this.selectedPlan.Id +
        //   "/member-group/" +
        //   this.memberGroup.IdentityId +
        //   "/Drugs"
        // );
      }
      if (this.memberGroup === null || this.memberGroup === undefined) {
        return (
          this.settings.APIURL + "cms/plans/" + this.selectedPlan.Id + "/Drugs"
        );
      }
      return (
        this.settings.APIURL +
        "cms/plans/" +
        this.selectedPlan.Id +
        "/member-group/" +
        this.memberGroup.IdentityId +
        "/Drugs"
      );
    },
  },
  async mounted() {
    if (this.cms) {
      this.setUrls();
    }
    this.memberGroups = (await this.getMemberGroupsWithDate({
      plan: this.selectedPlan.Id,
      date: this.$helpers.nowFormatted(),
      url: "?$expand=Translations",
    })).data.value;
  },
  watch: {
    cms: {
      handler(v) {
        if (v) {
          this.setUrls();
        }
      },
    },
    memberGroup: {
      handler(v) {
        // console.log(v);
        this.setUrls();
      },
    },
  },
  methods: {
    ...mapActions("downloadCenter", [
      "deleteDrug",
      "setBaseUrl",
      "setBaseOdataUrl",
    ]),
    ...mapActions("plansMembers", ["getMemberGroupsWithDate"]),
    edit(item) {
      this.editdrug = item;
    },
    async remove(item) {
      try {
        await this.deleteDrug(item);
        this.$refs.table.getDataAsync();
      } catch (e) {
        this.error = e;
      }
    },
    setUrls() {
      if (this.cms === "old") {
        this.setBaseOdataUrl("cms/odata/");
        this.setBaseUrl("cms/");
      } else {
        this.setBaseOdataUrl("cms/plans/" + this.selectedPlan.Id + "/");
        this.setBaseUrl("cms/plans/" + this.selectedPlan.Id + "/");
      }
      this.provider = new ODataProvider(
        this.$axiosHttp,
        this.url,
        this.headers
      );
    },
  },
};
</script>
